import { getChatSocket, ensureChatSocket } from "./chatSocketManager";

export { getChatSocket as getGroupSocket, ensureChatSocket as ensureGroupSocket };

/** @type {Map<string, Map<string, { message: object, timeoutId?: number }>>} */
const pendingByGroup = new Map();
const groupUploadListeners = new Set();

const notifyGroupUpload = (event, payload) => {
    groupUploadListeners.forEach((fn) => {
        try {
            fn(event, payload);
        } catch (err) {
            }
    });
};

export const subscribeGroupUploadEvents = (listener) => {
    groupUploadListeners.add(listener);
    return () => groupUploadListeners.delete(listener);
};

const getGroupMap = (groupId) => {
    const key = String(groupId);
    if (!pendingByGroup.has(key)) {
        pendingByGroup.set(key, new Map());
    }
    return pendingByGroup.get(key);
};

export const trackGroupPendingUpload = (groupId, tempId, message, timeoutId, { notify = false } = {}) => {
    const entry = { message: { ...message }, timeoutId };
    getGroupMap(groupId).set(String(tempId), entry);
    if (notify) {
        notifyGroupUpload("added", { groupId, tempId, message: entry.message });
    }
};

export const patchGroupPendingUpload = (groupId, tempId, patch, { notify = true } = {}) => {
    const map = pendingByGroup.get(String(groupId));
    if (!map) return null;
    const entry = map.get(String(tempId));
    if (!entry) return null;
    if (patch.uploading === false && entry.timeoutId) {
        clearTimeout(entry.timeoutId);
        entry.timeoutId = undefined;
    }
    entry.message = { ...entry.message, ...patch };
    if (notify) {
        notifyGroupUpload("updated", { groupId, tempId, message: entry.message });
    }
    return entry.message;
};

export const clearGroupPendingUpload = (groupId, tempId, { notify = true } = {}) => {
    const map = pendingByGroup.get(String(groupId));
    if (!map) return;
    const entry = map.get(String(tempId));
    if (entry?.timeoutId) clearTimeout(entry.timeoutId);
    map.delete(String(tempId));
    if (map.size === 0) pendingByGroup.delete(String(groupId));
    if (notify) {
        notifyGroupUpload("removed", { groupId, tempId });
    }
};

export const getGroupPendingUploadMessages = (groupId) => {
    const map = pendingByGroup.get(String(groupId));
    if (!map) return [];
    return [...map.values()].map((entry) => entry.message);
};

export const clearAllGroupPendingUploads = () => {
    pendingByGroup.forEach((groupMap) => {
        groupMap.forEach((entry) => {
            if (entry.timeoutId) clearTimeout(entry.timeoutId);
        });
    });
    pendingByGroup.clear();
};

export const mergeGroupMessagesWithPending = (messages, groupId) => {
    const pending = getGroupPendingUploadMessages(groupId);
    if (!pending.length) return messages;

    const existingTempIds = new Set(
        messages.map((m) => String(m.tempId || m.id || "")).filter(Boolean)
    );

    const toAppend = pending.filter((p) => {
        if (!p.uploading) return false;
        const id = String(p.tempId || p.id || "");
        return id && !existingTempIds.has(id);
    });

    if (!toAppend.length) return messages;
    return [...messages, ...toAppend];
};
